import { Badge } from './Badge.jsx';
import {
  DCMA_METRIC_LABELS_V6,
  DCMA_THRESHOLD_LABELS_V6,
  getV6ResultDisplay,
} from '../../engine/dcmaLabelsV6.js';

/**
 * DCMA point compliance card. `point` is one item from analysis.dcma.points.
 * Renders a PASS/FAIL badge plus the threshold + measured result, with
 * color cues matching the PDF.
 *
 * D-DcmaCardInline (SWEEP2-AUDIT Part 0): the inline card consumes the SAME
 * shared V6 labels the DCMA tab (DcmaTable) and the PDF (_dcma-table.ejs)
 * render — metric via DCMA_METRIC_LABELS_V6, threshold via
 * DCMA_THRESHOLD_LABELS_V6, result via getV6ResultDisplay. Previously it
 * rendered the raw engine fields, which diverged on #3 (">90%" vs "FS >90%"),
 * #9 ("14" vs "14 activities"), and #14 ("Valid + Continuous"/"Broken" vs
 * "Valid"/"Discontinuous"). One vocabulary, three surfaces (Rule 12).
 */
export function DcmaCard({ point }) {
  if (!point) return null;
  const passed = point.pass === true;
  const na = point.pass == null;
  const variant = na ? 'NA' : (passed ? 'OK' : 'CRITICAL');
  const label = na ? 'N/A' : (passed ? 'PASS' : 'FAIL');
  const resultColor = na
    ? 'var(--text-muted)'
    : (passed ? 'var(--pass)' : 'var(--crit)');
  const metricLabel = DCMA_METRIC_LABELS_V6[point.dcmaNumber] || point.metric;
  const thresholdLabel = DCMA_THRESHOLD_LABELS_V6[point.dcmaNumber] || point.dcmaThreshold;
  const resultText = getV6ResultDisplay(point) || '—';

  return (
    <div className={`dcma-card ${passed ? 'pass' : na ? 'na' : 'fail'}`}>
      <div className="dcma-top">
        <span className="dcma-name">
          #{point.dcmaNumber} {metricLabel}
        </span>
        <Badge variant={variant} size="sm">{label}</Badge>
      </div>
      <div className="dcma-detail">
        <span>Threshold: {thresholdLabel}</span>
        {' · '}
        <span>Result: <strong style={{ color: resultColor }}>{resultText}</strong></span>
      </div>
    </div>
  );
}
